import { useContext } from 'react'

import { ProviderContext } from '../../Provider'
import { ExplainerModalSectionStyles } from './ExplainerModalSectionStyles'
import { ExplainerSection } from './ExplainerSection'

export const ExplainerModalSection = () => {
  const {
    state: { isTrackerless },
  } = useContext(ProviderContext)
  return (
    <ExplainerModalSectionStyles>
      <ExplainerSection
        imageUrl="./v2/assets/explainerBackgrounds/how/pay-by-mile"
        title="Pay-by-mile is simple."
        text="A fixed cost covers your car while it’s parked. The rest depends on your mileage. So the less you drive, the less you pay. But your price won’t change based on when, where or how fast you drive."
      />
      <ExplainerSection
        imageUrl={`./v2/assets/explainerBackgrounds/how/set-up${isTrackerless ? '-connected' : ''}`}
        title="Getting set up is easy."
        text={
          isTrackerless
            ? 'As you have a connected car, just download our app and in a couple of clicks you’ll be all set. Once you’ve done that, we’ll count your miles automatically.'
            : 'We’ll send you a matchbox-sized box that you plug into your car in a matter of moments. Once you’ve done that, it counts your miles automatically.'
        }
      />
      <ExplainerSection
        imageUrl="./v2/assets/explainerBackgrounds/how/keep-track"
        title="Keep track using our app."
        text="Stay in control of your policy and spending in our app, get award-winning live chat support and look after your car using our handy tools."
      />
    </ExplainerModalSectionStyles>
  )
}
